import { useMediaQuery } from '@mui/material'
import { useState } from 'react'

import { BaseModal2 } from '@components/modals/BaseModal2'
import { Breadcrumb } from '@components/shared/Breadcrumb'
import { emotionTheme } from '@styles/theme'
import { Pagination } from '@components/shared/Table/components/Pagination'
import { Title } from '@components/shared/Title'

import type { UnitsListModalProps } from './types'

import * as S from './styles'

export const UnitsListModal = ({
  open,
  onClose,
  statusIcon,
  statusLabel,
  statusColor,
  statusBackground,
  listTitle,
  units
}: UnitsListModalProps) => {
  const isMobile = useMediaQuery(`(max-width: ${emotionTheme.screenSizes.laptop})`)
  const [itemsPerPage, setItemsPerPage] = useState(10)

  return (
    <BaseModal2
      open={open}
      onClose={onClose}
      width={isMobile ? 'calc(100% - 20px)' : '96.5%'}
      heightContainer="auto"
      maxHeightContainer={isMobile ? 'calc(100% - 20px)' : '95%'}
      headerIcon={
        <Breadcrumb
          breadcrumbData={[
            { label: 'Gestão Financeira' },
            { label: 'Prévia' },
            { label: 'Gestão da Prévia' },
            { label: 'Fluxo de Aprovação (das Unidades) - Lista das CLs no momento' }
          ]}
        />
      }
    >
      <Title label="Lista das CLs no momento" marginTop={0} />

      <S.TabBadge color={statusColor} background={statusBackground}>
        <S.Dot color={statusColor} />
        {statusLabel}
        <S.StatusCountBadge color={statusColor}>{units.length}</S.StatusCountBadge>
      </S.TabBadge>

      <S.DashedCard>
        <S.Card>
          <S.CardHeader>
            <S.IconWrapper color={statusColor}>{statusIcon}</S.IconWrapper>
            {listTitle}
          </S.CardHeader>

          <S.UnitList>
            {units.map((unit, index) => (
              <S.UnitRow key={`${unit}-${index}`}>{unit}</S.UnitRow>
            ))}
          </S.UnitList>

          <S.Footer>
            <Pagination
              currentPage={1}
              totalPages={1}
              itemsPerPage={itemsPerPage}
              totalItems={units.length}
              onPageChange={() => {}}
              onItemsPerPageChange={setItemsPerPage}
            />
          </S.Footer>
        </S.Card>
      </S.DashedCard>
    </BaseModal2>
  )
}
